// Clé PUBLIQUE RevenueCat iOS (publique par design — aucune clé secrète côté client).
export const REVENUECAT_IOS_KEY = 'appl_SsbnNpWzSKlxRNiOVXsxhwkGHfn';

// Clé PUBLIQUE RevenueCat Android (Google Play), app RevenueCat app3f0cec79ac.
// Publique par design, au même titre que la clé iOS. La variable d'environnement
// permet de la surcharger au build (EAS) sans toucher au code.
export const REVENUECAT_ANDROID_KEY =
  process.env.EXPO_PUBLIC_REVENUECAT_API_KEY_ANDROID ?? 'goog_FYrWhrnDBAWpoxQuOZxtPqWXnYg';

// Offering courant et identifiants de package (custom, pas $rc_monthly).
export const REVENUECAT_OFFERING = 'default';

// Plans achetables via RevenueCat. Les identifiants d'entitlement ET de package = ces clés exactes.
// L'ordre reflète la priorité de résolution (pro avant plus).
/**
 * Package ANNUEL de l'offering courant. Il ne figure pas dans `PurchasablePlan` : ce n'est pas un
 * plan de plus — l'entitlement accordé reste « pro » — mais une autre façon de payer le même plan.
 * Le webhook mappe d'ailleurs sur l'entitlement, jamais sur le produit : un achat annuel ouvre donc
 * le plan Pro sans qu'aucune ligne serveur n'ait à connaître ce nom.
 */
export const PRO_ANNUAL_PACKAGE = 'pro_annual';

export type PurchasablePlan = 'pro' | 'plus';
export const PURCHASABLE_PLANS: PurchasablePlan[] = ['pro', 'plus'];

/**
 * ═══════════════════════════════════════════════════════════════════════════════════════════════
 * RÈGLE NON NÉGOCIABLE — DEPUIS L'APP iOS, JAMAIS UN MOT NI UN LIEN VERS L'ACHAT WEB.
 * ═══════════════════════════════════════════════════════════════════════════════════════════════
 *
 * Apple 3.1.3(b) « Multiplatform Services » autorise qu'un abonnement acheté sur le site donne
 * accès au contenu dans l'app iOS, à condition que le même abonnement soit AUSSI proposé en achat
 * intégré. C'est ce qui rend le lot web possible. Ce que la règle n'autorise pas, et que 3.1.1
 * (anti-steering) interdit toujours hors storefront américain, c'est d'ORIENTER l'utilisateur vers
 * ce moyen de paiement depuis l'application.
 *
 * LA FRONTIÈRE EST DONC : **l'entitlement traverse, la promotion non.**
 *
 * Concrètement, sur iOS, rien de ce qui suit n'a le droit d'exister — ni dans le paywall, ni dans
 * les paramètres, ni dans un message d'erreur, ni dans un email déclenché par l'app :
 *
 *   ✗ un lien, un bouton ou un QR code vers la page d'abonnement du site ;
 *   ✗ l'URL du site écrite en toutes lettres, même non cliquable ;
 *   ✗ une phrase du genre « moins cher sur hormeia.fr », « abonne-toi sur notre site »,
 *     « disponible aussi sur le web » — la mention seule suffit à constituer l'orientation ;
 *   ✗ un prix web affiché en comparaison du prix App Store.
 *
 * Ce qui reste permis : reconnaître un entitlement acquis ailleurs, et l'ouvrir sans commentaire.
 * Un utilisateur déjà abonné par le web voit simplement son plan actif, sans qu'on lui dise d'où il
 * vient.
 *
 * POURQUOI C'EST ÉCRIT ICI plutôt que dans une revue de code : la tentation naît mécaniquement le
 * jour où `BILLING_AVAILABLE` vaut `false` quelque part, ou bien où un achat échoue. « Renvoyer
 * vers le site » est alors la solution évidente, et elle coûte le rejet de la mise à jour, voire du
 * compte. La contrainte doit donc être lisible depuis le module où l'on vient régler ces cas-là.
 *
 * Android est plus permissif depuis 2025 aux États-Unis, et Google évolue. ON NE SUIT QU'UNE SEULE
 * RÈGLE, LA PLUS STRICTE — le code de paywall est partagé, et deux comportements à retenir
 * produisent tôt ou tard le mauvais des deux sur la mauvaise plateforme.
 *
 * Voir aussi la section « Monétisation » de CLAUDE.md, qui porte la même règle.
 */
